/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-content[_ngcontent-%COMP%]{width:500px;overflow:visible}mat-dialog-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:20px}mat-dialog-content[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{width:350px}"];
export { styles as styles };
